import { render, staticRenderFns } from "./resetpwd.vue?vue&type=template&id=374d1483&scoped=true"
import script from "./resetpwd.vue?vue&type=script&lang=js"
export * from "./resetpwd.vue?vue&type=script&lang=js"
import style0 from "./resetpwd.vue?vue&type=style&index=0&id=374d1483&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374d1483",
  null
  
)

export default component.exports